import { useSelector } from "react-redux";

export const useAuth = () => {
  return useSelector((state) => state.session);
};

export const useUser = () => {
  return useAuth()?.user;
};

export const useUserId = () => {
  return useUser()?.id;
};

export const useUserRole = () => {
  return useUser()?.role;
};
